import { createStripeCheckout } from "@/api/stripe";
import { useUserStore } from "@plugins/2.pinia/modules/user";
import { store } from "@store";

const userStore = useUserStore(store);

const extractSession = (result) => ({
  url: result?.url ?? null,
});

export const createStripeCheckoutSession = async ({
  payload = {},
} = {}) => {
  const resolvedUserId = userStore?.userInfo?.uid || null;
  const resolvedProductId = payload?.productId || payload?.product_id || null;

  const metadata = {
    ...(payload?.metadata || {}),
    ...(resolvedUserId ? { user_id: String(resolvedUserId) } : {}),
    ...(resolvedProductId ? { product_id: String(resolvedProductId) } : {}),
  };

  console.log("[Stripe] create checkout session metadata:", metadata);

  const result = await createStripeCheckout({
    ...payload,
    ...(resolvedProductId ? { productId: String(resolvedProductId) } : {}),
    metadata,
  });

  const { url } = extractSession(result);
  if (!url) {
    throw new Error(
      "Create session endpoint did not return Checkout Session url",
    );
  }

  return { url, raw: result };
};

export const redirectToStripeCheckoutUrl = async (url) => {
  if (!url) throw new Error("Missing Checkout Session url");
  window.location.assign(url);
  return url;
};
